<template>
  <div>
    <v-row>
   
      <v-col cols="12 py-0">
        <ValidationObserver ref="observer">
          <v-card>
            <v-container fluid>
              <v-row class="ma-0 align-left">
                <v-col
                  cols="12"
                  sm="6"
                  lg="6"
                  md="6"
                  class="px-0 d-flex justify-space-between"
                >
                  <v-autocomplete
                    hide-details="auto"
                    hide-no-data
                    :items="Units"
                    clearable
                    outlined
                    v-model="SelectedTypes"
                    :search-input.sync="searchUnitTypes"
                    item-text="name"
                    item-value="id"
                    label="Select Types"
                    @input="SubmitData"
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>

              <v-row v-if="showdatas || selectedTypeData">
              <v-row>
                  <v-col
                    cols="auto"
                    v-for="(SelectedType, index) in selectedTypeData"
                    :key="name"
                  >
                    <v-card
                      style="border-radius: 10px !important"
                      width="280"
                      height="330px"
                    >
                      <v-row>
                        <v-col cols="12">
                          <!-- <v-checkbox
                            @change="disableAnotherCategories(SelectedType)"
                            v-model="SelectedType.sample"
                          ></v-checkbox> -->
                          <v-btn
                            icon
                            color="white"
                            class="closebutton"
                            @click="close(SelectedType, index)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                          <v-img
                            src="../../../../assets/food.jpg"
                            alt="Snow"
                            height="150px"
                            width="100%"
                          />

                          <div class="head">
                            {{ SelectedType.unit ? SelectedType.unit.name : SelectedType.name }}
                          </div>

                          <v-divider> </v-divider>
                        </v-col>
                        <div class="pricetag1" v-if="!SelectedType.is_adjust">
                          Price
                        </div>
                        <v-col
                          cols="12"
                          class="pricetag"
                          style="margin-bottom: -46px;"
                          ><v-checkbox
                            v-model="SelectedType.is_adjust"
                            :label="`Is Adjustable `"
                          ></v-checkbox
                        ></v-col>
                        <v-row v-if="SelectedType.is_adjust">
                          <v-col cols="1" class="pl-6 py-2">
                            <!-- <v-btn icon color="green"><v-icon>mdi-minus-box</v-icon></v-btn> -->
                          </v-col>

                          <v-col cols="3" class="px-1 labelend">
                            <ValidationProvider v-slot="{ errors }" name="Gram">
                              <label for="" v-if="SelectedType.is_adjust"
                                ><b>Price</b></label
                              >
                              <v-text-field
                                outlined
                                type="number"
                                @input="SelectedType.priceError = []"
                                v-model="SelectedType.price"
                                :error-messages="SelectedType.priceError"
                                :rules="PriceRoles"
                                 label="Price"
                                dense
                                hide-details="auto"
                                class="price-field"
                              ></v-text-field>
                            </ValidationProvider>
                          </v-col>

                          <v-col cols="3" style="padding-top: 39px;">
                            <label><b>Equal To</b></label></v-col
                          >
                          <v-col cols="3" class="px-1 labelend">
                            <ValidationProvider
                              v-slot="{ errors }"
                              name="Price"
                            >
                              <label for=""><b>Grams</b></label>
                              <v-text-field
                                outlined
                                type="number"
                                @input="SelectedType.GramError = []"
                                v-model="SelectedType.quantity"
                                :error-messages="SelectedType.GramError"
                                :rules="GramRoles"
                              ></v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12">
                            <label style="margin-left:50px"
                              ><b> * You Must be Entry in Grams</b></label
                            >
                          </v-col>
                        </v-row>

                        <v-row v-if="!SelectedType.is_adjust">
                          <v-col cols="4" class="pl-6 py-2">
                            <!-- <v-btn icon color="green"><v-icon>mdi-minus-box</v-icon></v-btn> -->
                          </v-col>

                          <v-col
                            cols="4"
                            class="px-1"
                            style="margin-top: 20px;"
                          >
                            <ValidationProvider
                              v-slot="{ errors }"
                              name="Price"
                            >
                              <v-text-field
                                outlined
                                type="number"
                                @input="SelectedType.priceError = []"
                                v-model="SelectedType.price"
                                :error-messages="SelectedType.priceError"
                                :rules="PriceRoles"
                              ></v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="4" class="px-1 py-2">
                            <!-- <v-btn icon color="green"><v-icon>mdi-plus-box</v-icon></v-btn> -->
                          </v-col>
                        </v-row>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-row>

              <v-row v-if="showdatas || selectedTypeData">
                <v-col cols="10"></v-col>
                <v-col cols="2">
                  <v-btn color="primary" @click="submit"
                    >Update <v-icon>mdi-arrow-right-bold</v-icon></v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </ValidationObserver>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { required, email, max, regex } from "vee-validate/dist/rules";
import axios from "@/plugins/axios";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} is required",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});

export default {
  data: () => ({
    PriceRoles: [(v) => (v && v >= 0) || "Price should be above one"],
    SelectedTypes: null,
    selectedTypeData: [],
    showdatas: false,
    SelectBox: true,
    errors: [],
    searchUnitTypes:null,
    messages: [],
    Units: [],

    Types: [
      { name: "Full", priceError: [] },
      { name: "Half", priceError: [] },
      { name: "Normal", priceError: [] },
      { name: "Portion", priceError: [] },
    ],
  }),

  created() {
    this.GetUnitTypes();
  },

  components: {
    ValidationProvider,
    ValidationObserver,
  },
   props: {


    selectedTypeData: {
      type: Array,
      default: [],
    }
    
  },
   watch: {
    searchUnitTypes(value) {
      if (!value) {
        this.GetUnitTypes("");
      }

      this.GetUnitTypes(value);
    },
  },
  methods: {
     GetUnitTypes(query = "") {
       
      let except = [];
      this.selectedTypeData.map((p) => {
        const unitId = p.unit ? p.unit.id : p.id;
        if (unitId) except.push(unitId);
      });
      this.$store
        .dispatch("ingredients/GetUnitTypes", {
          query: query.searchQuery,
          except: except,
        })
        .then((res) => {
          console.log(res);
          this.Units = res.data.data;
        })
        .catch((err) => {});
    },
    async submit() {
      const isValid = await this.$refs.observer.validate();
      let error = false;
      this.selectedTypeData.map((p) => {
        if (!p.price || p.price <= 0) {
          p.priceError = [];
          error = true;
          p.priceError.push("price is required");
        }
         if (p.is_adjust) {
          if (!p.quantity || p.quantity <= 0) {
            error = true;
            (p.GramError = []), (p.GramError = ["Gram is required"]);
            p.priceError.push("Gram is required");
          }
        }
      });


       var temp=this.selectedTypeData
      this.selectedTypeData=[]
      this.selectedTypeData=temp
      
      if (isValid && !error) {
        const types = this.selectedTypeData.map((item) => ({
          unit_id: item.unit ? item.unit.id : item.id,
          price: Number(item.price),
          is_default: Boolean(item.sample != null ? item.sample : item.is_default),
          is_adjust: Boolean(item.is_adjust),
          quantity: item.is_adjust ? Number(item.quantity) : 0,
        }));
        if (types.length && !types.some((type) => type.is_default)) types[0].is_default = true;
        this.$emit("save", types);
      }
    },

    GetDatasTypes() {
      ;
      return this.selectedTypeData;
    },
    MoveNext() {
      ;
      this.$emit("nextTab", "");
    },
disableAnotherCategories(item){
  
  this.selectedTypeData.map(p=>{
    if(item.id!=p.id)
    {
      p.sample=false;
    }
  })

},
    close(selectdata, index) {
      if (selectdata) {
        this.selectedTypeData.splice(index, 1);
      }
      this.GetUnitTypes()
    },
    SubmitData() {
      ;
      this.showdatas = true;
      let selected = this.Units.find((p) => p.id == this.SelectedTypes);
      selected.sample=false;
      if (selected) {

        this.selectedTypeData.push({unit:selected});
      }
    },
  },
};
</script>
<style>
.price {
  margin-top: -15px;
  margin-left: 68px;
}
.head {
  text-align: center;
  text-overflow: inherit;
  font-size: 13px;
  font-weight: 750;
  background: whitesmoke;
}

.TypeImage {
  width: 100%;
  background-image: url("../../../../assets/food.jpg");
  /* background-image: url("https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__340.jpg"); */
}
.pricetag {
  font-size: 13px;
  font-weight: 800;
  margin-bottom: -39px;
  text-align: center;
  margin-left: 66px !important;
}
.labelend {
  margin-bottom: -30px !important;
}
.pricetag1 {
  font-size: 16px;
  font-weight: 800;
  margin-bottom: -39px;
  text-align: center;
  margin-left: 126px !important;
}
.closebutton {
  position: absolute;
  top: 9px;
  right: 5px;
  z-index: 2;
}
</style>
